import type { ListingActionDto, ListingActionsResponse } from '@pulsify/shared/dto'

interface ActionsPageView {
  /** The action the page leads with: today's, else the one running from an earlier day. */
  current: ListingActionDto | null
  sentToday: boolean
  canSend: boolean
  /** The running action a new one would end. */
  replaces: ListingActionDto | null
}

export function actionsPageView(overview: ListingActionsResponse): ActionsPageView {
  const current = overview.today ?? overview.running
  const canSend = overview.today === null
  return {
    current,
    sentToday: overview.today !== null,
    canSend,
    replaces: canSend ? overview.running : null,
  }
}
